import { useMutation } from "@tanstack/react-query"
import { createAxiosWithAuth } from "./middleware";

export const useApproveFuelRequest = () =>{   
  const axios = createAxiosWithAuth();

   return useMutation({
      mutationFn: async (query) => {
        return await axios.post('/fuelrequest/approve', query)
      },
    })
}